import React, { useState } from "react";
import {
  Button,
  Select,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  DialogActions,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import RegisterNewUser from "../../pages/RegisterNewUser";

export default function AddUserModal({
  refresh,
  setRefresh,
  setAlert,
  setAlertContent,
}) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div style={{ width: 100, paddingTop: 10 }}>
      <Button
        variant="contained"
        color="primary"
        sx={{  mr: "5px", backgroundColor: "#8bc34a" }}
        onClick={handleClickOpen}
      >
        + Add a user
      </Button>
      <Dialog
        maxWidth="md"
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle>
          <IconButton
            sx={{ float: "right", width: "40px" }}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <RegisterNewUser
            setOpen={setOpen}
            refresh={refresh}
            setRefresh={setRefresh}
            setAlert={setAlert}
            setAlertContent={setAlertContent}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}
